import type { HomeColorToken } from "@/modules/home";

/**
 * O canvas não resolve `var(--token)`: as cores das séries precisam chegar ao
 * Chart.js já calculadas. Os valores abaixo repetem os de `globals.css` e só
 * entram em uso quando a folha de estilo não está aplicada — no ambiente de
 * teste, por exemplo — de modo que a fonte da paleta continua sendo o CSS.
 */
const FALLBACK: Record<HomeColorToken, string> = {
  "--home-text": "#ffffff",
  "--home-chart-line": "#ffffff",
  "--home-chart-fill": "rgba(255, 255, 255, 0.28)",
  "--home-chart-grid": "rgba(255, 255, 255, 0.12)",
  "--home-chart-marker": "rgba(255, 255, 255, 0.85)",
};

export function resolveHomeColor(token: HomeColorToken): string {
  if (typeof document === "undefined") return FALLBACK[token];

  const value = getComputedStyle(document.documentElement).getPropertyValue(token).trim();

  return value || FALLBACK[token];
}
